<template>
    <div class="code-dialog">
        <el-dialog
            :model-value="visible"
            width="360"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <template #header>
                <div class="title-con">
                    <div class="title-txt">请输入邀请码</div>
                    <div
                        class="close-btn"
                        @click="
                            () => {
                                emits('on-close');
                            }
                        "
                    >
                        <i class="iconfont icon-a-guanbidanchuang"></i>
                    </div>
                </div>
            </template>
            <el-input
                v-model.trim="invitationCode"
                class="srt-el-input"
                placeholder="请输入"
                style="height: 32px"
            ></el-input>

            <template #footer>
                <div class="dialog-footer">
                    <el-button
                        class="srt-el-button srt-el-button--cancel srt-el-button-h32"
                        @click="cancel"
                        >取消</el-button
                    >
                    <el-button
                        class="srt-el-button srt-el-button--primary srt-el-button-h32"
                        @click="confirm"
                        >提交</el-button
                    >
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const emits = defineEmits(['on-close', 'on-confirm']);

const props = defineProps({
    visible: {
        type: Boolean,
        default: false,
    },
    projectDetail: {
        type: Object,
        default: () => {},
    },
});

const visible = computed({
    get: () => {
        return props.visible || false;
    },
    set: val => {
        return val;
    },
});

const invitationVisible = ref(false);

const invitationCode = ref('');

function cancel() {
    invitationCode.value = '';
    emits('on-close');
}

function confirm() {
    if(invitationCode.value !== '') {
        G_transmit('activateInvite', {
            name: 'activateInvite',
            data: {
                eventsId: props.projectDetail?.eventsId,
                inviteCode: invitationCode.value,
                projectId: props.projectDetail?.id,
            },
        })
            .then(({ status, data }) => {
                emits('on-confirm');
            })
            .catch(err => {
                console.log(err);
                G_dispatchEvent('toast', { message: err?.status?.desc, type: 'info' });
            });
    } else {
        G_dispatchEvent('toast', { message: '请输入邀请码', type: 'info' });
    }

}
watch(
    () => props.visible,
    () => {
        invitationCode.value = '';
    },
    {
        deep: true,
    },
);
</script>

<style lang="scss" scoped>
.code-dialog {
    .title-con {
        display: flex;
        align-items: center;
        position: relative;
        height: 100%;

        .iconfont {
            font-size: 16px;
            margin-right: 16px;
        }

        .title-txt {
            line-height: 24px;
            color: var(--color-black);
            font-size: 16px;
            font-weight: 600;
        }

        .close-btn {
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            position: absolute;
            right: -20px;

            .iconfont {
                color: rgba(0, 0, 0, 0.45);
                font-size: 12px;
            }

            &:hover {
                .iconfont {
                    color: var(--color-primary);
                }
            }
        }
    }

    .dialog-footer {
        display: flex;
        justify-content: flex-end;

        .srt-el-button {
            border-radius: 6px;
        }

        .srt-el-button-h32 {
            padding: 5px 19px;
        }
    }

    :deep(.el-dialog) {
        box-shadow:
            0px 9px 28px 8px rgba(0, 0, 0, 0.05),
            0px 6px 16px 0px rgba(0, 0, 0, 0.08),
            0px 3px 6px -4px rgba(0, 0, 0, 0.12);
        border-radius: 8px;
    }

    :deep(.el-dialog__header) {
        padding: 16px 24px;
    }

    :deep(.el-dialog__body) {
        padding: 8px 24px 32px;
    }

    :deep(.el-dialog__footer) {
        padding: 0 24px 20px 0;
    }
}
</style>
